import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui-kit/Card";
import { money } from "@/lib/format";

const TONE = {
  "0-30": "bg-status-paid",
  "31-60": "bg-status-partial",
  "61-90": "bg-status-void/70",
  "90+": "bg-status-void",
};

export function AgingBreakdown({ aging }) {
  const total = aging.reduce((s, b) => s + b.amount, 0);

  return (
    <Card data-testid="aging-breakdown">
      <CardHeader>
        <CardTitle>Outstanding invoice aging</CardTitle>
        <CardDescription>Unpaid invoice balances by days since issue.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {total <= 0 ? (
          <p className="py-2 text-sm text-muted-foreground" data-testid="aging-empty">No outstanding invoices.</p>
        ) : (
          aging.map((b) => (
            <div key={b.bucket} data-testid={`aging-${b.bucket}`}>
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">
                  {b.bucket} days{b.count ? ` · ${b.count} invoice${b.count === 1 ? "" : "s"}` : ""}
                </span>
                <span className="nums font-medium text-foreground">{money(b.amount)}</span>
              </div>
              <div className="mt-1.5 h-2 w-full overflow-hidden rounded-full bg-secondary">
                <div
                  className={`h-full rounded-full ${TONE[b.bucket]} transition-[width] duration-500`}
                  style={{ width: `${total ? Math.max(b.amount > 0 ? 4 : 0, (b.amount / total) * 100) : 0}%` }}
                />
              </div>
            </div>
          ))
        )}
      </CardContent>
    </Card>
  );
}
